export default __webpack_public_path__ + "assets/images/04e2ae307c05801078f416610bcbd353.png";